import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import type { ReportColumn, ReportRow } from "@/lib/reports/types";
import { rowsToCsv } from "@/lib/reports/report-csv";

export default function ReportExportButton({
  columns,
  rows,
  filename = "rapport.csv",
}: {
  columns: ReportColumn[];
  rows: ReportRow[];
  filename?: string;
}) {
  const onClick = () => {
    const csv = rowsToCsv(columns, rows);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="outline" size="sm" onClick={onClick}>
      <SrIcon name="download" className="mr-2 h-4 w-4" />
      Eksporter
    </Button>
  );
}
